import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigService } from '../../services/config/config.service';

export const maintenanceGuard: CanActivateFn = async (route, state) => {
	const configService = inject(ConfigService);
	const router = inject(Router);

	await configService.loadConfig();
	const projectData = configService.getConfig();

	if (!projectData?.maintenanceMode?.active) {
		router.navigateByUrl('/');
		return false;
	}
	return true;
};
